<template>
    <PopupOrderMoredataWindow ref="popupOrderMoredataWindow"></PopupOrderMoredataWindow>
    <div id="my_orders_page" class="order-data-history-page">
        <PopupWindow
            v-if="isVisiblePopup"
            :key="modal"
            :popupName="modal.popupName"
            :header="modal.header"
            :info="modal.info"
            :buttonText="modal.button"
            :callback="modal.callback"
            :buttonText2="modal.button2"
            :color="modal.color"
        ></PopupWindow>
        <RateOrderWindow
            v-if="isVisibleRateOrder"
            :key="rate_order"
            :service_name="rate_order.service_name"
            :ratecallback="rate_order.ratecallback"
        ></RateOrderWindow>
        <div class="order-data-section">
            <div class="order-data" id="repeat_orders">
                <div class="order-data__list">
                    <div
                        v-for="order in c_orders"
                        :key="order"
                        :id="'current_order_' + order.order_number"
                        class="order-data__list-item"
                    >
                        <!-- <div class="">
                            <div class="">
                                <p v-if="order.status_num >= 2 || order.order_data_link == ''">
                                    Заказ №{{ order.order_number }}
                                </p>
                                <a v-else :href="order.order_data_link">Заказ №{{ order.order_number }}</a>
                            </div>
                            <div class="">
                                <img
                                    src="../../../assets/IMGS/SVG/printer.svg"
                                    alt="printer"
                                    v-on:click="showPrintPage(order.order_number)"
                                />
                            </div>
                        </div> -->
                        <!-- <div class="">
                            <div class="">
                                <div class="">
                                    <div class="">
                                        <div class="progress_all">
                                            <div class="progress_container">
                                                <div
                                                    v-bind:class="{
                                                        progress_box: true,
                                                        box_red: order.status_num >= 1,
                                                    }"
                                                >
                                                    <p
                                                        v-bind:class="{
                                                            progress_number: true,
                                                            box_number_red: order.status_num >= 1,
                                                        }"
                                                    >
                                                        1
                                                    </p>
                                                </div>
                                                <p
                                                    v-bind:class="{
                                                        progress_text: true,
                                                        box_text_red: order.status_num >= 1,
                                                    }"
                                                >
                                                    Заказ запланирован
                                                </p>
                                            </div>
                                            <div
                                                v-bind:class="{
                                                    progress_rect: true,
                                                    progress_rect_red: order.status_num >= 2,
                                                }"
                                            ></div>
                                            <div class="progress_container">
                                                <div
                                                    v-bind:class="{
                                                        progress_box: true,
                                                        box_red: order.status_num >= 2,
                                                    }"
                                                >
                                                    <p
                                                        v-bind:class="{
                                                            progress_number: true,
                                                            box_number_red: order.status_num >= 2,
                                                        }"
                                                    >
                                                        2
                                                    </p>
                                                </div>
                                                <p
                                                    v-bind:class="{
                                                        progress_text: true,
                                                        box_text_red: order.status_num >= 2,
                                                    }"
                                                >
                                                    Выезд исполнителя
                                                </p>
                                            </div>
                                            <div
                                                v-bind:class="{
                                                    progress_rect: true,
                                                    progress_rect_red: order.status_num >= 3,
                                                }"
                                            ></div>
                                            <div class="progress_container">
                                                <div
                                                    v-bind:class="{
                                                        progress_box: true,
                                                        box_red: order.status_num >= 3,
                                                    }"
                                                >
                                                    <p
                                                        v-bind:class="{
                                                            progress_number: true,
                                                            box_number_red: order.status_num >= 3,
                                                        }"
                                                    >
                                                        3
                                                    </p>
                                                </div>
                                                <p
                                                    v-bind:class="{
                                                        progress_text: true,
                                                        box_text_red: order.status_num >= 3,
                                                    }"
                                                >
                                                    Заказ выполняется
                                                </p>
                                            </div>
                                            <div
                                                v-bind:class="{
                                                    progress_rect: true,
                                                    progress_rect_red: order.status_num >= 4,
                                                }"
                                            ></div>
                                            <div class="progress_container">
                                                <div
                                                    v-bind:class="{
                                                        progress_box: true,
                                                        box_red: order.status_num >= 4,
                                                    }"
                                                >
                                                    <p
                                                        v-bind:class="{
                                                            progress_number: true,
                                                            box_number_red: order.status_num >= 4,
                                                        }"
                                                    >
                                                        4
                                                    </p>
                                                </div>
                                                <p
                                                    v-bind:class="{
                                                        progress_text: true,
                                                        box_text_red: order.status_num >= 4,
                                                    }"
                                                >
                                                    Заказ выполнен
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="">
                                    <div class="">
                                        <img
                                            src="../../../assets/IMGS/SVG/calendar_grey.svg"
                                            alt="calendar"
                                            style="width: 18px; height: 18px"
                                        />
                                        <div class="order_date" style="padding-left: 15px">
                                            {{ order.order_data_n_time }}
                                        </div>
                                        <template v-if="order.is_invalid">
                                            <img
                                                src="../../../assets/IMGS/SVG/invalidPeople.svg"
                                                alt="invalidPeople"
                                            />
                                        </template>
                                        <template v-if="order.is_pregnant">
                                            <img
                                                src="../../../assets/IMGS/SVG/pregnantPeople.svg"
                                                alt="pregnantPeople"
                                            />
                                        </template>
                                        <template v-if="order.is_child">
                                            <img
                                                src="../../../assets/IMGS/SVG/child.svg"
                                                alt="child"
                                            />
                                        </template>
                                        <div class="">{{ order.order_patient_info }}</div>
                                    </div>
                                    <div
                                        class=""
                                    >
                                        {{ order.order_price }} p
                                    </div>
                                    <div
                                        class=""
                                    >
                                        <p>{{ translateStatusIntoShorter(order.order_status) }}</p>
                                        <img
                                            src="../../../assets/IMGS/SVG/info_grey.svg"
                                            alt="info"
                                        />
                                    </div>
                                </div>
                                <div class="">
                                    <div class="">
                                        <div class="">
                                            <div class="">
                                                <img
                                                    src="../../../assets/IMGS/SVG/clock.svg"
                                                    alt="clock"
                                                    style="width: 18px; height: 18px"
                                                />
                                                <div class="order_time_container">
                                                    <div class="order_time">{{ order.order_time_in }}</div>
                                                </div>
                                                <img
                                                    src="../../../assets/IMGS/SVG/arrow_green_r.svg"
                                                    alt="arrow"
                                                />
                                                <div class="">{{ order.order_address_in }}</div>
                                            </div>
                                        </div>
                                        <div class="">
                                            <div class="">
                                                <div class="">
                                                    <div class=""></div>
                                                </div>
                                                <img
                                                    src="../../../assets/IMGS/SVG/arrow_green_r.svg"
                                                    alt="arrow"
                                                />
                                                <div class="">{{ order.order_address_out }}</div>
                                            </div>
                                        </div>

                                        <div v-if="order.order_is_return && order.if_wait">
                                            <div class="">
                                                <div class="">
                                                    <div class=""></div>
                                                </div>
                                                <img
                                                    src="../../../assets/IMGS/SVG/arrow_green_l.svg"
                                                    alt="arrow"
                                                />
                                                <div class="">{{ order.order_address_in }}</div>
                                            </div>
                                        </div>

                                        <div v-else-if="order.order_is_return">
                                            <div class="">
                                                <img
                                                    src="../../../assets/IMGS/SVG/clock.svg"
                                                    alt="clock"
                                                    style="width: 18px; height: 18px"
                                                />
                                                <div class="">
                                                    <div class="">
                                                        <div class="">{{ order.order_time_out }}</div>
                                                    </div>
                                                </div>
                                                <img
                                                    src="../../../assets/IMGS/SVG/arrow_green_l.svg"
                                                    alt="arrow"
                                                />
                                                <div class="">{{ order.order_address_in }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class=""
                                    >
                                        <div class="">
                                            <div
                                                class=""
                                            >
                                                <img
                                                    style="
                                                        position: absolute;
                                                        text-align: right;
                                                        left: -40px;
                                                        top: 17px;
                                                        height: 18.38px;
                                                        width: 21px;
                                                        filter: invert(20%) sepia(33%) saturate(7380%)
                                                            hue-rotate(120deg) brightness(94%) contrast(89%);
                                                    "
                                                    src="../../../assets/IMGS/SVG/car.svg"
                                                    alt="car"
                                                />
                                                <p class="">Ваш перевозчик:</p>
                                                <p
                                                    class=""
                                                    
                                                >
                                                    {{ order.order_service }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="">
                                            <div
                                                class=""
                                            >
                                                <img
                                                    style="
                                                        position: absolute;
                                                        text-align: right;
                                                        left: -40px;
                                                        top: 14px;
                                                        height: 23;
                                                    "
                                                    src="../../../assets/IMGS/SVG/phone_2.svg"
                                                    alt="phone"
                                                />
                                                <p class="">{{ order.order_phone }}</p>
                                                <p class="" style="padding-left: 5px">
                                                    {{ order.order_phone_2 }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="">
                                    <div
                                        class=""
                                    >
                                        <input
                                            id="сancel"
                                            type="submit"
                                            value="Отменить"
                                            class="backbutton"
                                            v-on:click="cancelOrder(order.order_number)"
                                        />
                                        <input
                                            id="repeat"
                                            type="submit"
                                            value="Повторить"
                                            class="backbutton"
                                            v-on:click="repeatOrder(order.order_number, 1)"
                                        />
                                        <input
                                            id="repeat_for_another_patient"
                                            type="submit"
                                            v-on:click="repeatOrder(order.order_number, 0)"
                                            value="Повторить для другого пациента"
                                            class="backbutton"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <!-- order-data-item -->
                        <div class="order-data-item">
                            <div class="order-data-item__title">
                                <template v-if="order.status_num >= 2 || order.order_data_link == ''">
                                    Заказ №{{ order.order_number }}
                                </template>
                                <a v-else :href="order.order_data_link">Заказ №{{ order.order_number }}</a>
                            </div>

                            <div class="order-data-item__card">
                                <div class="container-fluid">
                                    <!-- STATUS -->
                                    <div class="row">
                                        <div class="m_progress_all">
                                            <div class="m_progress_container">
                                                <div
                                                    v-bind:class="{
                                                        m_progress_box: true,
                                                        m_box_red: order.status_num >= 1,
                                                    }"
                                                >
                                                    <p
                                                        v-bind:class="{
                                                            m_progress_number: true,
                                                            m_box_number_red: order.status_num >= 1,
                                                        }"
                                                    >
                                                        1
                                                    </p>
                                                </div>
                                                <p
                                                    v-bind:class="{
                                                        m_progress_text: true,
                                                        m_box_text_red: order.status_num >= 1,
                                                    }"
                                                >
                                                    Заказ запланирован
                                                </p>
                                            </div>
                                            <div
                                                v-bind:class="{
                                                    m_progress_rect: true,
                                                    m_progress_rect_red: order.status_num >= 2,
                                                }"
                                            ></div>
                                            <div class="m_progress_container">
                                                <div
                                                    v-bind:class="{
                                                        m_progress_box: true,
                                                        m_box_red: order.status_num >= 2,
                                                    }"
                                                >
                                                    <p
                                                        v-bind:class="{
                                                            m_progress_number: true,
                                                            m_box_number_red: order.status_num >= 2,
                                                        }"
                                                    >
                                                        2
                                                    </p>
                                                </div>
                                                <p
                                                    v-bind:class="{
                                                        m_progress_text: true,
                                                        m_box_text_red: order.status_num >= 2,
                                                    }"
                                                >
                                                    Выезд исполнителя
                                                </p>
                                            </div>
                                            <div
                                                v-bind:class="{
                                                    m_progress_rect: true,
                                                    m_progress_rect_red: order.status_num >= 3,
                                                }"
                                            ></div>
                                            <div class="m_progress_container">
                                                <div
                                                    v-bind:class="{
                                                        m_progress_box: true,
                                                        m_box_red: order.status_num >= 3,
                                                    }"
                                                >
                                                    <p
                                                        v-bind:class="{
                                                            m_progress_number: true,
                                                            m_box_number_red: order.status_num >= 3,
                                                        }"
                                                    >
                                                        3
                                                    </p>
                                                </div>
                                                <p
                                                    v-bind:class="{
                                                        m_progress_text: true,
                                                        m_box_text_red: order.status_num >= 3,
                                                    }"
                                                >
                                                    Заказ выполняется
                                                </p>
                                            </div>
                                            <div
                                                v-bind:class="{
                                                    m_progress_rect: true,
                                                    m_progress_rect_red: order.status_num >= 4,
                                                }"
                                            ></div>
                                            <div class="m_progress_container">
                                                <div
                                                    v-bind:class="{
                                                        m_progress_box: true,
                                                        m_box_red: order.status_num >= 4,
                                                    }"
                                                >
                                                    <p
                                                        v-bind:class="{
                                                            m_progress_number: true,
                                                            m_box_number_red: order.status_num >= 4,
                                                        }"
                                                    >
                                                        4
                                                    </p>
                                                </div>
                                                <p
                                                    v-bind:class="{
                                                        m_progress_text: true,
                                                        m_box_text_red: order.status_num >= 4,
                                                    }"
                                                >
                                                    Заказ выполнен
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- ./STATUS -->

                                    <!-- SUMMARY -->
                                    <div class="row order-data-item__heading">
                                        <div class="col">
                                            <div class="order-data-item__heading-summary">
                                                <div class="order-data-item__heading-summary-datetime">
                                                    <img
                                                        src="../../../assets/IMGS/SVG/calendar_grey.svg"
                                                        alt="calendar"
                                                        style="width: 18px; height: 18px"
                                                    />
                                                    <div class="order-data-item__heading-summary-datetime-text">
                                                        {{ order.order_data_n_time }}
                                                    </div>
                                                </div>

                                                <div class="order-data-item__heading-summary-state">
                                                    <template v-if="order.is_invalid">
                                                        <img
                                                            src="../../../assets/IMGS/SVG/invalidPeople.svg"
                                                            alt="invalidPeople"
                                                            style="
                                                                filter: invert(20%) sepia(33%) saturate(7380%)
                                                                    hue-rotate(120deg) brightness(94%) contrast(89%);
                                                            "
                                                        />
                                                    </template>
                                                    <template v-if="order.is_pregnant">
                                                        <img
                                                            src="../../../assets/IMGS/SVG/pregnantPeople.svg"
                                                            alt="pregnantPeople"
                                                            style="
                                                                filter: invert(20%) sepia(33%) saturate(7380%)
                                                                    hue-rotate(120deg) brightness(94%) contrast(89%);
                                                            "
                                                        />
                                                    </template>
                                                    <template v-if="order.is_child">
                                                        <img
                                                            src="../../../assets/IMGS/SVG/child.svg"
                                                            alt="child"
                                                            style="
                                                                filter: invert(20%) sepia(33%) saturate(7380%)
                                                                    hue-rotate(120deg) brightness(94%) contrast(89%);
                                                            "
                                                        />
                                                    </template>
                                                </div>

                                                <div class="order-data-item__heading-summary-patient">
                                                    {{ order.order_patient_info }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-auto">
                                            <div class="row">
                                                <div
                                                    class="col-12 col-md-auto order-data-item__heading-price d-flex align-items-center justify-content-center"
                                                >
                                                    {{ order.order_price }} ₽
                                                </div>

                                                <div
                                                    class="col-12 col-md-auto order-data-item__heading-status d-flex align-items-center justify-content-center"
                                                    :class="{
                                                        'order-data-item__heading-status--current': true,
                                                    }"
                                                >
                                                    <div>{{ translateStatusIntoShorter(order.order_status) }}</div>
                                                    <img src="../../../assets/IMGS/SVG/info_grey.svg" alt="info" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- ./ SUMMARY -->

                                    <!-- DESCRIPTION -->
                                    <div class="order-data-item__description row gy-3 py-3">
                                        <div class="col-12 col-md-8">
                                            <table>
                                                <tr>
                                                    <td>
                                                        <div>
                                                            <img src="../../../assets/IMGS/SVG/clock.svg" alt="clock" />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="departure">{{ order.order_time_in }}</div>
                                                    </td>
                                                    <td>
                                                        <div class="d-flex align-items-center" style="padding-top: 2px">
                                                            <img
                                                                src="../../../assets/IMGS/SVG/arrow_green_r.svg"
                                                                alt="arrow"
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="destination">{{ order.order_address_in }}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>
                                                        <div class="d-flex align-items-center" style="padding-top: 2px">
                                                            <img
                                                                src="../../../assets/IMGS/SVG/arrow_green_r.svg"
                                                                alt="arrow"
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="destination">{{ order.order_address_out }}</div>
                                                    </td>
                                                </tr>
                                                <tr v-if="order.order_is_return && order.if_wait">
                                                    <td></td>
                                                    <td></td>
                                                    <td>
                                                        <div class="d-flex align-items-center" style="padding-top: 2px">
                                                            <img
                                                                src="../../../assets/IMGS/SVG/arrow_green_l.svg"
                                                                alt="arrow"
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="destination">{{ order.order_address_in }}</div>
                                                    </td>
                                                </tr>
                                                <tr v-else-if="order.order_is_return">
                                                    <td>
                                                        <div>
                                                            <img src="../../../assets/IMGS/SVG/clock.svg" alt="clock" />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="departure">{{ order.order_time_out }}</div>
                                                    </td>
                                                    <td>
                                                        <div class="d-flex align-items-center" style="padding-top: 2px">
                                                            <img
                                                                src="../../../assets/IMGS/SVG/arrow_green_l.svg"
                                                                alt="arrow"
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="destination">{{ order.order_address_in }}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <div class="col-12 col-md-4">
                                            <div class="mt-2">
                                                <div class="d-inline-flex align-items-start">
                                                    <img
                                                        src="../../../assets/IMGS/SVG/car.svg"
                                                        alt="car"
                                                        style="
                                                            margin-right: 12px;
                                                            filter: invert(20%) sepia(33%) saturate(7380%)
                                                                hue-rotate(120deg) brightness(94%) contrast(89%);
                                                        "
                                                    />
                                                    <div>
                                                        Ваш перевозчик: <strong>{{ order.order_service }}</strong>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <div class="d-inline-flex align-items-start">
                                                    <img
                                                        src="../../../assets/IMGS/SVG/phone_2.svg"
                                                        alt="phone"
                                                        style="margin-right: 12px"
                                                    />
                                                    <div>
                                                        <strong
                                                            >{{ order.order_phone
                                                            }}{{ `${order.order_phone_2 ? ', ' : ''}`
                                                            }}{{ order.order_phone_2 }}</strong
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <div class="row g-2">
                                                <div class="col-auto">
                                                    <button
                                                        id="сancel"
                                                        class="ui-button ui-button--md ui-button--red"
                                                        v-on:click="cancelOrder(order.order_number)"
                                                    >
                                                        Отменить
                                                    </button>
                                                </div>
                                                <div class="col-auto">
                                                    <button
                                                        id="repeat"
                                                        class="ui-button ui-button--md ui-button--secondary"
                                                        v-on:click="repeatOrder(order.order_number, 1)"
                                                    >
                                                        Повторить
                                                    </button>
                                                </div>
                                                <div class="col-auto">
                                                    <button
                                                        id="repeat_for_another_patient"
                                                        v-on:click="repeatOrder(order.order_number, 0)"
                                                        class="ui-button ui-button--md ui-button--grey"
                                                    >
                                                        Повторить для другого пациента
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- ./ DESCRIPTION -->
                                </div>
                            </div>
                        </div>
                        <!-- ./order-data-item -->
                    </div>
                </div>

                <div id="order_history">
                    <div class="">
                        <div class="">
                            <p style="font-size: 20px; font-weight: 700">История заказов</p>
                            <p
                                v-for="year in order_history_years"
                                :id="'year_' + year"
                                v-bind:class="{ history_year: true, selected: year == order_history_chosen_year }"
                                :key="year"
                                v-on:click="selectYear(year)"
                            >
                                {{ year }}
                            </p>
                        </div>
                    </div>
                    <div
                        id="choose_orders_select_box"
                        class="select-box custom-select my-3"
                        style="width: 355px"
                        v-on:click="reRender()"
                    >
                        <div class="myarrow" style="margin-right: 20px"></div>
                        <div id="choose_orders_selected" class="selected_option">
                            <p id="choose_orders" class="selected_text">Все заказы</p>
                        </div>
                        <div id="choose_orders_options" class="options" style="z-index: 1">
                            <div id="choose_orders_option1" class="option">
                                <p id="choose_orders_option1_text" class="option_text">Все заказы</p>
                            </div>
                            <div id="choose_orders_option2" class="option">
                                <p id="choose_orders_option2_text" class="option_text">Выполнен</p>
                            </div>
                            <div id="choose_orders_option3" class="option">
                                <p id="choose_orders_option3_text" class="option_text">Отменен</p>
                            </div>
                            <div id="choose_orders_option4" class="option">
                                <p id="choose_orders_option4_text" class="option_text">Отказ</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="order-data" id="repeat_orders_history">
                        <div class="order-data__list">
                            <div v-if="!has_loaded_once" class="loading_text">
                                Данные загружаются, пожалуйста, подождите
                            </div>
                            <div v-else-if="h_orders.length == 0" style="padding-left: 0px">
                                <p>Нет предыдущих заказов</p>
                            </div>
                            <div
                                v-for="order in h_orders"
                                :key="order"
                                :id="'order_example' + order.id"
                                class="order-data__list-item"
                            >
                                <!-- order-data-item -->
                                <div class="order-data-item order-data-item--grayscale">
                                    <div class="order-data-item__card">
                                        <div class="container-fluid">
                                            <!-- SUMMARY -->
                                            <div class="row order-data-item__heading">
                                                <div class="col">
                                                    <div class="order-data-item__heading-summary">
                                                        <div class="order-data-item__heading-summary-number">
                                                            {{ order.order_number }}
                                                        </div>
                                                        <div class="order-data-item__heading-summary-datetime">
                                                            <div class="order-data-item__heading-summary-datetime-text">
                                                                {{ order.order_date }}
                                                            </div>
                                                        </div>

                                                        <div class="order-data-item__heading-summary-state">
                                                            <template v-if="order.is_invalid">
                                                                <img
                                                                    src="../../../assets/IMGS/SVG/invalidPeople.svg"
                                                                    alt="invalidPeople"
                                                                    style="
                                                                        filter: invert(45%) sepia(6%) saturate(357%)
                                                                            hue-rotate(123deg) brightness(98%)
                                                                            contrast(87%);
                                                                    "
                                                                />
                                                            </template>
                                                            <template v-if="order.is_pregnant">
                                                                <img
                                                                    src="../../../assets/IMGS/SVG/pregnantPeople.svg"
                                                                    alt="pregnantPeople"
                                                                    style="
                                                                        filter: invert(45%) sepia(6%) saturate(357%)
                                                                            hue-rotate(123deg) brightness(98%)
                                                                            contrast(87%);
                                                                    "
                                                                />
                                                            </template>
                                                            <template v-if="order.is_child">
                                                                <img
                                                                    src="../../../assets/IMGS/SVG/child.svg"
                                                                    alt="child"
                                                                    style="
                                                                        filter: invert(45%) sepia(6%) saturate(357%)
                                                                            hue-rotate(123deg) brightness(98%)
                                                                            contrast(87%);
                                                                    "
                                                                />
                                                            </template>
                                                        </div>

                                                        <div class="order-data-item__heading-summary-patient">
                                                            {{ order.order_patient_info }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12 col-md-auto">
                                                    <div class="row">
                                                        <div
                                                            class="col-12 col-md-auto order-data-item__heading-price d-flex align-items-center justify-content-center"
                                                        >
                                                            {{ order.order_price }} ₽
                                                        </div>

                                                        <div
                                                            class="col-12 col-md-auto order-data-item__heading-status d-flex align-items-center justify-content-center"
                                                            :class="{
                                                                'order-data-item__heading-status--cancelled':
                                                                    order['order_status'] == 'Отменен',
                                                                'order-data-item__heading-status--current': true,
                                                            }"
                                                        >
                                                            <div>
                                                                {{ translateStatusIntoShorter(order.order_status) }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- ./ SUMMARY -->

                                            <!-- DESCRIPTION -->
                                            <div class="order-data-item__description row gy-3 py-3">
                                                <div class="col-12 col-md-8">
                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <div>
                                                                    <img
                                                                        src="../../../assets/IMGS/SVG/clock_grey.svg"
                                                                        alt="clock"
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="departure">{{ order.order_time_in }}</div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="d-flex align-items-center"
                                                                    style="padding-top: 2px"
                                                                >
                                                                    <img
                                                                        src="../../../assets/IMGS/SVG/arrow_grey_r.svg"
                                                                        alt="arrow"
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="destination">
                                                                    {{ order.order_address_in }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <div
                                                                    class="d-flex align-items-center"
                                                                    style="padding-top: 2px"
                                                                >
                                                                    <img
                                                                        src="../../../assets/IMGS/SVG/arrow_grey_r.svg"
                                                                        alt="arrow"
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="destination">
                                                                    {{ order.order_address_out }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="order.order_is_return && order.if_wait">
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <div
                                                                    class="d-flex align-items-center"
                                                                    style="padding-top: 2px"
                                                                >
                                                                    <img
                                                                        src="../../../assets/IMGS/SVG/arrow_grey_l.svg"
                                                                        alt="arrow"
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="destination">
                                                                    {{ order.order_address_in }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-else-if="order.order_is_return">
                                                            <td>
                                                                <div>
                                                                    <img
                                                                        src="../../../assets/IMGS/SVG/clock_grey.svg"
                                                                        alt="clock"
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="departure">{{ order.order_time_out }}</div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="d-flex align-items-center"
                                                                    style="padding-top: 2px"
                                                                >
                                                                    <img
                                                                        src="../../../assets/IMGS/SVG/arrow_grey_l.svg"
                                                                        alt="arrow"
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="destination">
                                                                    {{ order.order_address_in }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>

                                                <div class="col-12 col-md-4">
                                                    <div class="mt-2">
                                                        <div class="d-inline-flex align-items-start">
                                                            <img
                                                                src="../../../assets/IMGS/SVG/car_grey.svg"
                                                                alt="car"
                                                                style="margin-right: 12px"
                                                            />
                                                            <div>
                                                                Ваш перевозчик:
                                                                <strong>{{ order.order_service }}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="order.is_broken == 'true'" class="mt-2">
                                                        <div class="d-inline-flex align-items-start">
                                                            <img
                                                                style="
                                                                    position: absolute;
                                                                    text-align: right;
                                                                    left: -45px;
                                                                    top: 11px;
                                                                    width: 30px;
                                                                "
                                                                src="../../../assets/IMGS/SVG/car_accident.svg"
                                                                alt="car_accident"
                                                            />
                                                            <p class="order_tag">Серьезная поломка транспорта</p>
                                                        </div>
                                                    </div>
                                                    <div v-if="order.is_canceled == 'true'" class="mt-2">
                                                        <div class="d-inline-flex align-items-start">
                                                            <img
                                                                style="
                                                                    position: absolute;
                                                                    text-align: right;
                                                                    left: -41px;
                                                                    top: 14px;
                                                                    width: 23px;
                                                                "
                                                                src="../../../assets/IMGS/SVG/info_black.svg"
                                                                alt="info"
                                                            />
                                                            <div>ИСПОЛНИТЕЛЬ ОТМЕНИЛ ЗАКАЗ</div>
                                                        </div>
                                                    </div>
                                                    <div v-if="order.is_rated == true" class="mt-2">
                                                        <div class="d-inline-flex align-items-start">
                                                            <img
                                                                src="../../../assets/IMGS/SVG/like_grey.svg"
                                                                alt="info"
                                                                style="margin-right: 12px;"
                                                            />
                                                            <div>
                                                                <div class="mb-1">Ваша оценка исполнителя:</div>

                                                                <img
                                                                    v-for="order in order.star_count"
                                                                    :key="order"
                                                                    style="
                                                                        padding-left: 10px;
                                                                        padding-right: 10px;
                                                                        height: 21px;
                                                                    "
                                                                    src="../../../assets/IMGS/SVG/star_grey.svg"
                                                                    alt="star"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12">
                                                    <div class="row g-2">
                                                        <div class="col-auto">
                                                            <button
                                                                id="repeat"
                                                                class="ui-button ui-button--md ui-button--grey"
                                                                v-on:click="repeatOrder(order.order_number, 1)"
                                                            >
                                                                Повторить
                                                            </button>
                                                        </div>
                                                        <div class="col-auto">
                                                            <button
                                                                id="repeat_for_another_patient"
                                                                v-on:click="repeatOrder(order.order_number, 0)"
                                                                class="ui-button ui-button--md ui-button--grey"
                                                            >
                                                                Повторить для другого пациента
                                                            </button>
                                                        </div>
                                                        <div
                                                            class="col-auto"
                                                            v-if="
                                                                order.order_service != '' &&
                                                                order.order_service != null &&
                                                                !order.is_rated
                                                            "
                                                        >
                                                            <button
                                                                id="сancel"
                                                                class="ui-button ui-button--md ui-button--grey"
                                                                v-on:click="
                                                                    showRateOrder(
                                                                        order.order_number,
                                                                        order.order_service
                                                                    )
                                                                "
                                                            >
                                                                Оценить
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- ./ DESCRIPTION -->
                                        </div>
                                    </div>
                                </div>
                                <!-- ./order-data-item -->
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="d-flex">
                            <div class="flex-item item_8" style="text-align: left; display: flex">
                                <p style="font-size: 20px; line-height: 120%; color: #6e7675; font-weight: 700">
                                    Страница
                                </p>
                                <p
                                    v-for="key in amountOfHistoryPages"
                                    :key="key"
                                    v-on:click="
                                        historyOrdersSelectedPage = key - 1;
                                        reRender();
                                        scrollToHistoryOrders();
                                    "
                                    v-bind:class="{
                                        history_year: true,
                                        selected: key - 1 == historyOrdersSelectedPage,
                                    }"
                                >
                                    {{ key }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import $ from 'jquery';
import tools from '@/assets/js/tools.js';
import popup from '../../ModalComponent.vue';
import rateOrderWindow from '../../RateOrderComponent.vue';
import { useCookies } from 'vue3-cookies';
import PopupOrderMoredataWindow from '../../ModalOrderMoredata.vue';

var history_orders = [];
var current_orders = [];
var order_history_years = [];
var status_dict = { Создан: 0, Подтвержден: 0, Запланирован: 1, Выезд: 2, Выполняется: 3, 'Выполнение просрочено': 4 };
var cache_status = {};

export default {
    name: 'MyOrdersPage',
    el: '#my_orders_page',
    components: {
        PopupWindow: popup,
        RateOrderWindow: rateOrderWindow,
        PopupOrderMoredataWindow: PopupOrderMoredataWindow,
    },
    data() {
        return {
            isMobile: false,
            modal: {
                popupName: 'default',
                header: 'Подтверждение',
                info: '',
                color: '#0ECCAA',
                button: '',
                button2: '',
                callback: function () {},
            },
            rate_order: {
                ratecallback: function () {},
                service_name: '',
            },
            isVisiblePopup: false,
            order_history_years: order_history_years,
            order_history_chosen_year: 0,
            translateStatusIntoShorter: tools.translateStatusIntoShorter,
            h_orders: history_orders,
            historyOrdersSelectedPage: 0,
            ORDERS_PER_PAGE: 10,
            amountOfHistoryPages: 0,
            c_orders: current_orders,
            currentKey: 1,
            has_loaded_once: false,
            isVisibleRateOrder: false,
        };
    },
    setup() {
        const { cookies } = useCookies();
        return { cookies };
    },
    mounted() {
        const DOMisAlive = document.getElementById('my_orders_page');
        if (DOMisAlive) {
            this.isMobile = this.getMobileScreen();
            if (this.getCookie('mtu_refresh_token') == '' || this.getCookie('mtu_refresh_token') == null) {
                window.location.href = '/authorization';
                return;
            }
            let select_box_names = ['choose_orders'];
            let select_box_options_amounts = [4];
            document.getElementById('my_orders_page').addEventListener('click', function () {
                for (let select_box_name of select_box_names) {
                    if (document.getElementById(select_box_name + '_select_box').classList.contains('open_tmp')) {
                        document.getElementById(select_box_name + '_select_box').classList.remove('open_tmp');
                    } else {
                        document.getElementById(select_box_name + '_select_box').classList.remove('opened');
                        document.getElementById(select_box_name + '_options').style.display = 'none';
                    }
                }
            });
            for (let select_id in select_box_names) {
                let select_box_name = select_box_names[select_id];
                document.getElementById(select_box_name + '_selected').addEventListener('click', function () {
                    if (document.getElementById(select_box_name + '_select_box').classList.contains('opened')) {
                        document.getElementById(select_box_name + '_select_box').classList.remove('opened');
                        document.getElementById(select_box_name + '_options').style.display = 'none';
                    } else {
                        document.getElementById(select_box_name + '_select_box').classList.add('opened');
                        document.getElementById(select_box_name + '_select_box').classList.add('open_tmp');
                        document.getElementById(select_box_name + '_options').style.display = 'flex';
                    }
                });

                for (
                    let select_box_option = 1;
                    select_box_option <= select_box_options_amounts[select_id];
                    select_box_option++
                ) {
                    document
                        .getElementById(select_box_name + '_option' + select_box_option)
                        .addEventListener('click', function () {
                            document.getElementById(select_box_name + '_options').style.display = 'none';

                            for (
                                let selboxoption = 1;
                                selboxoption <= select_box_options_amounts[select_id];
                                selboxoption++
                            ) {
                                if (selboxoption == select_box_option) {
                                    document
                                        .getElementById(select_box_name + '_option' + selboxoption)
                                        .classList.add('current');
                                } else {
                                    document
                                        .getElementById(select_box_name + '_option' + selboxoption)
                                        .classList.remove('current');
                                }
                            }
                            document.getElementById(select_box_name + '').innerText = document.getElementById(
                                select_box_name + '_option' + select_box_option + '_text'
                            ).innerText;
                            document.getElementById(select_box_name + '_select_box').classList.remove('opened');
                        });
                }
            }
            $('#choose_orders_option1').click();

            this.reRender();
            setInterval(() => {
                this.reRender();
            }, 5000);
        }
    },
    created() {
        this.isMobile = this.getMobileScreen();
    },
    methods: {
        getMobileScreen() {
            if (screen.width <= 1024) {
                return true;
            } else {
                return false;
            }
        },
        getCookie(val) {
            return this.cookies.get(val);
        },
        scrollToHistoryOrders() {
            $('#choose_orders_selected')[0].scrollIntoView({ behavior: 'smooth' });
        },
        showRateOrder(order_id, service_name) {
            var vm = this;
            this.rate_order = {
                ratecallback: function (rate_amount, comment) {
                    $.ajax({
                        type: 'GET',
                        xhrFields: { withCredentials: true },
                        url:
                            global.BACKEND_URL +
                            `/my_orders/api_button/rate_order?order_id=${order_id}&rate=${rate_amount}&comment=${comment}`,
                        success: function () {
                            vm.reRender();
                            console.log('Rate OK');
                        },
                        error: function () {
                            console.log('Rate Not success :(');
                        },
                        dataType: 'text',
                        contentType: 'application/json',
                    });
                },
                service_name: service_name,
            };
            this.isVisibleRateOrder = true;
            this.reRender();
        },
        selectYear(current_year) {
            this.order_history_chosen_year = current_year;
            this.reRender();
        },
        helpCalcImgSizesMargins(doc, canvas) {
            const SCALE = 0.9;
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const calcWidth = (canvas.width * pageHeight) / canvas.height;
            const calcHeight = (canvas.height * pageWidth) / canvas.width;
            var imgWidth = pageWidth;
            var imgHeight = calcHeight;
            if (imgHeight > pageHeight) {
                imgWidth = calcWidth;
                imgHeight = pageHeight;
            }
            imgWidth *= SCALE;
            imgHeight *= SCALE;
            return [(pageWidth - imgWidth) / 2, (pageHeight - imgHeight) / 2, imgWidth, imgHeight];
        },
        pdfElement(curOrd, pdfName, callback) {
            var vm = this;
            var doc = new jsPDF('l', 'px', 'A4');
            html2canvas(curOrd).then((canvas) => {
                const img = canvas.toDataURL('image/png');
                var imgSizes = vm.helpCalcImgSizesMargins(doc, canvas);
                doc.addImage(img, 'PNG', imgSizes[0], imgSizes[1], imgSizes[2], imgSizes[3]);
                doc.save(pdfName + '.pdf');
                if (callback) callback();
            });
        },
        showPrintPage(order_id) {
            var vm = this;
            vm.repeatOrder(order_id, 2, function (dat) {
                const locationsTravel = ['По городу / региону', 'По России', 'Между странами'];
                const transportTypes = [
                    ['Автомобиль', ['Санитарная перевозка', 'Скорая помощь', 'Реанимация']],
                    ['Самолет', ['Не выбрано']],
                    ['Водный транспорт', ['Не выбрано']],
                    ['Поезд', ['Не выбрано']],
                ];
                var trans1 = transportTypes[parseInt(dat['transportType1'])];
                var trans2 = parseInt(dat['transportType2']);
                if (trans2 == -1) {
                    trans2 = 'Не выбрано';
                } else {
                    trans2 = trans1[1][trans2];
                }
                trans1 = trans1[0];
                var trans_sum = trans1 + ' - ' + trans2;
                if (trans2.startsWith('Не выбрано')) trans_sum = trans1;

                console.log(dat);

                var from_address_add_info = '';
                if (dat['floorFrom'] != '' && dat['floorFrom'] != 'null')
                    from_address_add_info += ', этаж ' + dat['floorFrom'];
                if (dat['isElevatorFrom'] == 'false') from_address_add_info += ', без лифта';
                if (dat['isElevatorFrom'] == 'true') {
                    if (dat['isCargoElevatorFrom'] == 'true') {
                        from_address_add_info += ', с грузовым лифтом';
                    } else {
                        from_address_add_info += ', с лифтом, без грузового';
                    }
                }
                var to_address_add_info = '';
                if (dat['floorTo'] != '' && dat['floorTo'] != 'null') to_address_add_info += ', этаж ' + dat['floorTo'];
                if (dat['isElevatorTo'] == 'false') to_address_add_info += ', без лифта';
                if (dat['isElevatorTo'] == 'true') {
                    if (dat['isCargoElevatorTo'] == 'true') {
                        to_address_add_info += ', с грузовым лифтом';
                    } else {
                        to_address_add_info += ', с лифтом, без грузового';
                    }
                }

                var escort = dat['escort'];
                if (escort == 'не требуется') escort = 'cопровождение не требуется';
                else escort = 'сопровождение: ' + escort;
                var weight = dat['weight'];
                if (weight != '' && weight != 'null' && weight != '0') weight = weight + ' кг, ';
                else weight = '';
                document.querySelector('#confirmation_popup #customer_last_window').innerText =
                    dat['customerName'] +
                    ' ' +
                    dat['customerPatronymic'] +
                    ', т. ' +
                    dat['customerPhone'] +
                    ', e-mail: ' +
                    dat['customerEmail'];
                document.querySelector('#confirmation_popup #patient_last_window').innerText =
                    dat['patientName'] +
                    ' ' +
                    dat['patientPatronymic'] +
                    ' ' +
                    dat['patientSurname'] +
                    ', ' +
                    (dat['maleGender'] ? 'М' : 'Ж') +
                    ', ' +
                    dat['patientAge'] +
                    ' лет, ' +
                    weight +
                    escort;
                document.querySelector('#confirmation_popup #contact_last_window').innerText =
                    dat['contactName'] + ', ' + dat['contactPhoneNumber'];
                if (dat['customerName'] == dat['patientName'] && dat['customerPatronymic'] == dat['patientPatronymic'])
                    document.querySelector('#confirmation_popup #contact_last_window').innerText = '';
                document.querySelector('#confirmation_popup #transport_last_window').innerText = trans_sum;
                document.querySelector('#confirmation_popup #way_last_window').innerText =
                    locationsTravel[parseInt(dat['area'])];
                document.querySelector('#confirmation_popup #where_last_window').innerText =
                    dat['addressTo'] + to_address_add_info;
                document.querySelector('#confirmation_popup #from_last_window').innerText =
                    dat['addressFrom'] + from_address_add_info;
                document.querySelector('#confirmation_popup #when_last_window').innerText =
                    dat['dateStart'] + ', ' + dat['timeStart'];
                document.querySelector('#confirmation_popup #comment_last_window').innerText = dat['comment'];
                vm.$refs.popupOrderMoredataWindow.setForPrint(true, order_id);
                vm.$refs.popupOrderMoredataWindow.showModal();
                vm.$refs.popupOrderMoredataWindow.setCallback(function () {
                    vm.$refs.popupOrderMoredataWindow.hideButtons();
                    vm.pdfElement(
                        document.getElementById('confirmation_popup_centered'),
                        'Заказ' + order_id,
                        function () {
                            vm.$refs.popupOrderMoredataWindow.closeModal();
                        }
                    );
                });
            });
        },
        repeatOrder(order_id, type_of_repeat, callbackfunc) {
            $.ajax({
                type: 'GET',
                xhrFields: { withCredentials: true },
                url:
                    global.BACKEND_URL +
                    `/my_orders/api_button/repeat_order?order_id=${order_id}&version=${type_of_repeat}`,
                success: function (data) {
                    if (callbackfunc) {
                        callbackfunc(data);
                    } else {
                        localStorage.repeatOrderData = JSON.stringify(data);
                        window.location.href = '/order?repeat=true';
                    }
                },
                error: function () {
                    console.log('Repeat order: Not success');
                },
                dataType: 'json',
                contentType: 'application/json',
            });
        },
        cancelOrder(order_id) {
            var vm = this;
            vm.modal = {
                popupName: 'cancelOrder',
                header: 'Подтвреждение',
                info: 'Укажите, пожалуйста причину отмены заказа',
                button: 'Отменить заказ',
                button2: 'Не отменять заказ',
                color: '#0ECCAA',
                callback: function (element, comment) {
                    if (element === 'Отменить заказ') {
                        $.ajax({
                            type: 'GET',
                            xhrFields: { withCredentials: true },
                            url:
                                global.BACKEND_URL +
                                `/my_orders/api_button/cancel_order?order_id=${order_id}&comment=${comment}`,
                            success: function () {
                                vm.reRender();
                            },
                            error: function () {
                                console.log('Cancel order: Not success');
                            },
                            dataType: 'text',
                            contentType: 'application/json',
                        });
                    }
                },
            };
            vm.isVisiblePopup = true;
        },
        reRender() {
            const DOMisAlive = document.getElementById('my_orders_page');
            if (DOMisAlive) {
                var vm = this;
                var status_filter = 0;
                if (document.getElementById('choose_orders').innerText == 'Выполнен') {
                    status_filter = 1;
                }
                if (document.getElementById('choose_orders').innerText == 'Отменен') {
                    status_filter = 2;
                }
                if (document.getElementById('choose_orders').innerText == 'Отказ') {
                    status_filter = 3;
                }
                $.ajax({
                    type: 'GET',
                    xhrFields: { withCredentials: true },
                    url: global.BACKEND_URL + `/my_orders/get_orders?typeOfOrder=${status_filter}`,
                    success: function (data) {
                        vm.has_loaded_once = true;
                        history_orders = [];
                        current_orders = [];
                        order_history_years = [];

                        var keys = Object.keys(data);

                        order_history_years = keys;
                        order_history_years.splice(order_history_years.indexOf('active'), 1);
                        order_history_years.sort((a, b) => parseInt(b) - parseInt(a));
                        vm.order_history_years = order_history_years;
                        vm.amountOfHistoryPages = 0;
                        if (!vm.order_history_chosen_year || data[vm.order_history_chosen_year.toString()] == undefined)
                            vm.order_history_chosen_year = vm.order_history_years[0];
                        if (
                            !vm.order_history_chosen_year ||
                            data[vm.order_history_chosen_year.toString()] == undefined
                        ) {
                            keys = ['active'];
                        } else {
                            keys = ['active', vm.order_history_chosen_year.toString()];
                            vm.amountOfHistoryPages = Math.ceil(data[keys[1]].length / vm.ORDERS_PER_PAGE);
                        }

                        if (vm.amountOfHistoryPages < vm.historyOrdersSelectedPage) vm.historyOrdersSelectedPage = 0;
                        var currentHistoryOrderNumber = 0;
                        keys.forEach((key) => {
                            order_history_years = order_history_years.concat([key]);
                            data[key].forEach((singular_order) => {
                                if (key == 'active') {
                                    current_orders = current_orders.concat([
                                        {
                                            order_number: singular_order['orderId'],
                                            order_data_n_time: singular_order['orderDate'],
                                            order_patient_info: singular_order['patientData'],
                                            order_price: singular_order['price'],
                                            order_status: singular_order['status'],
                                            status_num: status_dict[singular_order['status']],
                                            order_time_in: singular_order['timeStart'],
                                            order_address_in: singular_order['address1'],
                                            order_time_out: singular_order['timeEnd'],
                                            order_address_out: singular_order['address2'],
                                            order_service: singular_order['organisationName'],
                                            order_is_return: singular_order['isReturn'] == 'true',
                                            order_phone: singular_order['organisationPhone'],
                                            order_phone_2: '',
                                            if_wait: singular_order['waitSpot'] == 'true',
                                            is_invalid: singular_order['isInvalid'] == 'true',
                                            is_pregnant: singular_order['isPregnant'] == 'true',
                                            is_child: singular_order['isChild'] == 'true',
                                            order_data_link: singular_order['order_data_link'],
                                        },
                                    ]);
                                } else {
                                    currentHistoryOrderNumber += 1;
                                    if (
                                        currentHistoryOrderNumber <=
                                            vm.historyOrdersSelectedPage * vm.ORDERS_PER_PAGE ||
                                        currentHistoryOrderNumber >
                                            (vm.historyOrdersSelectedPage + 1) * vm.ORDERS_PER_PAGE
                                    )
                                        return;
                                    history_orders = history_orders.concat([
                                        {
                                            order_number: singular_order['orderId'],
                                            order_date: singular_order['orderDate'],
                                            order_patient_info: singular_order['patientData'],
                                            order_price: singular_order['price'],
                                            order_status: singular_order['status'],
                                            order_time_in: singular_order['timeStart'],
                                            order_address_in: singular_order['address1'],
                                            order_time_out: singular_order['timeEnd'],
                                            order_address_out: singular_order['address2'],
                                            order_service: singular_order['organisationName'],
                                            order_is_return: singular_order['isReturn'] == 'true',
                                            is_broken: false,
                                            is_canceled: false,
                                            is_rated: singular_order['rate'] != '0',
                                            star_count: parseInt(singular_order['rate']),
                                            if_wait: singular_order['waitSpot'] == 'true',
                                            is_invalid: singular_order['isInvalid'] == 'true',
                                            is_pregnant: singular_order['isPregnant'] == 'true',
                                            is_child: singular_order['isChild'] == 'true',
                                        },
                                    ]);
                                }
                            });
                        });

                        current_orders.forEach((order) => {
                            if (
                                order['order_status'] == 'Приостановлен' &&
                                cache_status[order['order_number']] != 'Приостановлен' &&
                                cache_status[order['order_number']] != null
                            ) {
                                (vm.modal = {
                                    header: 'Информация',
                                    info: `Заказ №${order['order_number']} был приостановлен диспетчером! Для уточнения обстоятельств свяжитесь с диспетчером напрямую.`,
                                    button: 'ОК',
                                    color: '#0ECCAA',
                                }),
                                    (vm.isVisiblePopup = true);
                            }
                        });
                        history_orders.forEach((order) => {
                            if (
                                order['order_status'] == 'Отменен Исполнителем' &&
                                cache_status[order['order_number']] != 'Отменен Исполнителем' &&
                                cache_status[order['order_number']] != null
                            ) {
                                (vm.modal = {
                                    header: 'Информация',
                                    info: `Заказ №${order['order_number']} был отменен диспетчером! Для уточнения обстоятельств свяжитесь с диспетчером напрямую.`,
                                    button: 'ОК',
                                    color: '#0ECCAA',
                                }),
                                    (vm.isVisiblePopup = true);
                            }
                        });
                        vm.c_orders = current_orders;
                        current_orders.forEach((order) => {
                            cache_status[order.order_number] = order.order_status;
                        });
                        history_orders.forEach((order) => {
                            cache_status[order.order_number] = order.order_status;
                        });
                        vm.h_orders = history_orders;
                    },
                    error: function () {
                        console.log('Not success :(');
                    },
                    dataType: 'json',
                    contentType: 'application/json',
                });
                this.currentKey += 1;
            }
        },
    },
};
</script>

<style lang="css" scoped src="@/assets/css/my_orders.css"></style>

<style lang="scss">
.order-data {
    // color: #747474;

    &__list {
        &-item {
            margin-bottom: 32px;
        }
    }

    .order-data-item {
        color: #747474;

        &__title {
            font-size: 20px;
            font-weight: 700;
            margin-bottom: 24px;
        }

        &__card {
            font-size: 16px;
            border: 1px solid rgba(116, 116, 116, 0.1);
            border-left: 8px solid #0eccaa;
        }

        &__heading {
            background-color: #b8f4ea;

            &-summary {
                display: flex;
                flex-wrap: wrap;
                gap: 8px 22px;
                padding: 16px 0;

                color: #6e7675;

                &-datetime {
                    display: inline-flex;
                    align-items: center;
                    gap: 12px;

                    &-text {
                        font-size: 18px;
                        font-weight: 700;
                        white-space: no-wrap;
                    }
                }

                &-state {
                    display: inline-flex;
                    align-items: center;
                    gap: 14px;
                }

                &-patient {
                    font-size: 16px;
                }
            }

            &-price {
                min-width: 100px;
                height: 54px;
                font-size: 20px;
                font-weight: 700;
                background-color: #d8e8e6;
            }

            &-status {
                min-width: 238px;
                height: 54px;

                gap: 12px;
                color: #fff;
                font-size: 18px;
                font-weight: 500;
                text-transform: uppercase;

                &--current {
                    background-color: #0eccaa;
                }

                &--cancelled {
                    background-color: #ee6870 !important;
                }
            }
        }

        &__description {
            table {
                tr {
                    td {
                        padding: 12px 0;

                        &:nth-child(1) {
                            width: 18px;
                        }

                        &:nth-child(3) {
                            width: 22px;
                        }

                        .departure {
                            padding: 0 8px;
                            font-weight: 700;
                        }

                        .destination {
                            padding-left: 8px;
                        }

                        @media screen and (min-width: 768px) {
                            .departure {
                                padding: 0 40px 0 18px;
                            }

                            .destination {
                                padding-left: 28px;
                            }
                        }
                    }
                }
            }
        }

        &__offers {
            &-title {
                font-size: 20px;
                font-weight: 700;
            }

            &-list {
                gap: 24px;

                .carrier-item {
                    &__info {
                        display: flex;
                        gap: 8px 18px;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                        background-color: rgba(75, 172, 227, 0.1);
                        border-radius: 8px;
                        height: 100%;
                        font-size: 20px;
                        font-weight: 700;
                    }
                }
            }
        }

        //#eceded
        //e1e1e1
        &--grayscale {
            .order-data-item__card {
                border-left-color: #98a09f;
            }

            .order-data-item__heading {
                background-color: #eceded;
            }

            .order-data-item__heading-price {
                background-color: #e1e1e1;
            }

            .order-data-item__heading-status {
                &--current {
                    background-color: #bec5c4;
                }

                &--cancelled {
                    background-color: #ffb4b8 !important;
                }
            }
        }
    }
}

.m_progress_all {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    background: #f2fffd;
    padding-top: 30px;
    padding-bottom: 30px;
}

.m_progress_container {
    width: 25%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-end;
}

.m_progress_box {
    border: 2px solid #e1e4e4;
    height: 31px;
    width: 31px;
    background: #fff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.m_progress_text {
    color: #adb3b2;
    margin-top: 8px;
    margin-bottom: 0px;
    font-size: 10px;
    line-height: 1;
    text-align: center;

    @media screen and (min-width: 576px) {
        font-size: 12px;
    }

    @media screen and (min-width: 768px) {
        font-size: 14px;
    }

    @media screen and (min-width: 992px) {
        font-size: 18px;
    }
}

.m_progress_number {
    font-size: 15px;
    font-weight: bolder;
    color: #adb3b2;
}

.m_progress_rect {
    background: #e1e4e4;
    height: 3px;
    width: 100%;
    max-width: 140px;
}

.m_box_border_in {
    animation: box_border_to_red 0.5s linear;
}

.m_box_border_out {
    animation: box_border_to_red 0.5s linear reverse;
}

.m_box_text_red_in {
    animation: box_text_to_red 0.5s linear;
}

.m_box_text_red_out {
    animation: box_text_to_red 0.5s linear reverse;
}

.m_box_text_white_in {
    animation: box_text_to_white 0.5s linear;
}

.m_box_text_white_out {
    animation: box_text_to_white 0.5s linear reverse;
}

.m_box_background_in {
    animation: box_background_to_red 0.5s linear;
}

.m_box_background_out {
    animation: box_background_to_red 0.5s linear reverse;
}

.m_progress_bar_in {
    animation: progress_bar_to_red 0.5s linear;
}

.m_progress_bar_out {
    animation: progress_bar_to_red 0.5s linear reverse;
}

@keyframes box_border_to_red {
    from {
        border-color: #e1e4e4;
    }

    to {
        border-color: #ee6870;
    }
}

@keyframes box_text_to_red {
    from {
        color: #adb3b2;
    }

    to {
        color: #ee6870;
    }
}

@keyframes box_text_to_white {
    from {
        color: #ee6870;
    }

    to {
        color: #fff;
    }
}

@keyframes box_background_to_red {
    from {
        background: #fff;
    }

    to {
        background: #ee6870;
    }
}

@keyframes progress_bar_to_red {
    from {
        background: #e1e4e4;
    }

    to {
        background: #ee6870;
    }
}
</style>
